(function () {
  var KEY_DONE = 'cpz_subscribed', KEY_DISMISS = 'cpz_popup_dismissed', KEY_URL = 'cpz_guide_url';
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  var KEY_PENDING = 'cpz_pending_signup';
  function getS(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function setS(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function delS(k) { try { sessionStorage.removeItem(k); } catch (e) {} }

  // Send a copy of a signup to Klaviyo (Theme settings > Email collection).
  function postToKlaviyo(p) {
    var co = window.CP_KLAVIYO_COMPANY, list = window.CP_KLAVIYO_LIST;
    if (!p || !p.email || !/^[A-Za-z0-9]{6}$/.test(co || '') || !/^[A-Za-z0-9]{6}$/.test(list || '')) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + co, { method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription',
          attributes: { custom_source: p.source || 'guide-signup',
            profile: { data: { type: 'profile', attributes: { email: p.email, properties: { signup_source: p.source || '', signup_page: p.page || '' } } } } },
          relationships: { list: { data: { type: 'list', id: list } } } } }) });
    } catch (e) {}
  }

  // The form is submitted the normal way, so Shopify runs its own spam check and saves the
  // customer. We only remember the email for a moment; once Shopify has accepted it (the page
  // comes back showing the guide link) the copy goes to Klaviyo. Nothing is sent if Shopify says no.
  document.querySelectorAll('form.signup').forEach(function (form) {
    var ok = form.querySelector('.signup-success a.btn');
    if (ok) { set(KEY_DONE, '1'); set(KEY_URL, ok.href); }
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[type=email]'), tag = form.querySelector('input[name="contact[tags]"]');
      if (input && input.value) setS(KEY_PENDING, JSON.stringify({ email: input.value.trim(), source: tag ? tag.value : '', page: location.pathname }));
      var btn = form.querySelector('button[type=submit]');
      if (btn) setTimeout(function () { btn.disabled = true; btn.textContent = 'Sending...'; }, 0);
    });
  });
  window.addEventListener('pageshow', function (e) {            // back button: undo the "Sending..." state
    if (!e.persisted) return;
    document.querySelectorAll('form.signup button[type=submit]').forEach(function (b) { b.disabled = false; });
  });

  var pending = getS(KEY_PENDING);
  if (pending) {
    if (document.querySelector('form.signup .signup-success')) { delS(KEY_PENDING); try { postToKlaviyo(JSON.parse(pending)); } catch (e) {} }
    else if (document.querySelector('form.signup .error')) delS(KEY_PENDING);      // Shopify rejected it
  }

  var unlocked = !!get(KEY_DONE);
  var navLinks = document.querySelectorAll('[data-guide-link]');
  navLinks.forEach(function (l) { if (unlocked) l.classList.add('unlocked'); });

  // Returning subscriber on the Guide page: show their guide button again.
  var gurl = get(KEY_URL);
  var pageForm = document.getElementById('guide-signup');
  if (pageForm && gurl && /^https:\/\//.test(gurl)) {
    var fields = pageForm.querySelector('.signup-fields');
    if (fields) {
      var box = document.createElement('div'); box.className = 'signup-success success'; box.setAttribute('role', 'status');
      var t = document.createElement('p'); t.className = 'success-title'; t.textContent = 'Guide unlocked';
      var x = document.createElement('p'); x.className = 'success-text'; x.textContent = 'Your guide is ready.';
      var a = document.createElement('a'); a.className = 'btn'; a.href = gurl; a.target = '_blank'; a.rel = 'noopener'; a.textContent = 'Open the guide';
      box.appendChild(t); box.appendChild(x); box.appendChild(a);
      fields.replaceWith(box);
    }
  }

  var popup = document.getElementById('email-popup');
  if (!popup) return;
  function open() { popup.hidden = false; document.body.classList.add('popup-open'); var i = popup.querySelector('input[type=email]'); if (i) i.focus(); }
  function close() { popup.hidden = true; document.body.classList.remove('popup-open'); set(KEY_DISMISS, String(Date.now())); }
  popup.querySelectorAll('[data-popup-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });

  // Locked Guide tab: ask for the email instead of opening the page.
  if (!unlocked) navLinks.forEach(function (l) { l.addEventListener('click', function (e) { e.preventDefault(); open(); }); });

  // Came back from a popup signup: show the guide link in the popup.
  if (popup.querySelector('.signup-success')) { open(); return; }

  var dismissed = parseInt(get(KEY_DISMISS) || '0', 10);
  var recentlyDismissed = dismissed && Date.now() - dismissed < 7 * 864e5;
  if (get(KEY_DONE) || recentlyDismissed) return;
  setTimeout(open, (parseInt(popup.getAttribute('data-delay'), 10) || 5) * 1000);
})();
